import { render, staticRenderFns } from "./AffiliateRenewalSignatures.vue?vue&type=template&id=29dcd076"
import script from "./AffiliateRenewalSignatures.vue?vue&type=script&lang=ts"
export * from "./AffiliateRenewalSignatures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports